// A supplier's price list from a CSV or Excel file (docs/suppliers.md, "Preislisten-Import").
// Names, dates and units are appended by the component: the bundle escapes parameters.
export default {
  action: "Import price list",
  title: "Import price list",
  steps: {
    file: "File",
    columns: "Columns",
    matching: "Matching",
  },
  file: {
    label: "File",
    drop: "Drop a CSV or Excel file here or browse",
    limits: "CSV or Excel (.xlsx), up to 10 MB and 5000 lines",
    kind: "The price list holds",
    no_file: "Please choose a file first.",
    invalid_type: "Please choose a CSV or Excel file (.csv, .xlsx).",
    too_large: "The file is larger than 10 MB.",
    unreadable: "The file cannot be read. A CSV or Excel file with at most 5000 lines is expected.",
    expired: "The file is no longer available. Please upload it again.",
  },
  columns: {
    rows: "1 line | {n} lines",
    sheet: "Sheet",
    header_row: "First line is a header",
    field: "Field",
    column: "Column in the file",
    samples: "Samples",
    column_n: "Column {letter}",
    none: "No column",
    fields: {
      articleNumber: "Article number",
      name: "Name",
      price: "Price",
      unit: "Unit",
      currency: "Currency",
    },
    name_or_article: "Name or article number needed",
    currency: "Currency of the prices",
    currency_fallback: "Currency where none is given",
    valid_from: "New prices valid from",
  },
  matching: {
    row_failed: "Prices not loaded, please pick again",
    summary: {
      lines: "1 line read | {n} lines read",
      recognized: "{article} recognised by article number, {name} by name",
      unchanged: "1 price unchanged | {n} prices unchanged",
      // Machine lines whose row in the assortment bills in another unit (under "Unclear").
      other_unit: "1 in another unit | {n} in another unit",
    },
    groups_label: "Show lines",
    groups: {
      matched: "Matched",
      ambiguous: "Unclear",
      unmatched: "Not found",
      invalid: "Invalid",
    },
    hide_unchanged: "Hide unchanged",
    filter: "Filter lines",
    columns: {
      line: "In the file",
      problem: "Reason",
      price: "Price",
      change: "Change",
    },
    line: "Line",
    by_article: "by article number",
    by_name: "by name",
    new_row: "new in the assortment",
    new: "new",
    unchanged: "unchanged",
    skipped: "left out",
    skip: "Leave out",
    take: "Take over",
    reassign: "Assign differently",
    create: "Create new",
    suggestions: "Suggestions",
    materials: "More materials",
    machines: "More machines",
    // A machine line whose row in the assortment bills in another unit: not taken until assigned otherwise. The units
    // are words ("week", "day").
    unit_mismatch: "List per {line}, row per {row}",
    units: { HOUR: "hour", DAY: "day", WEEK: "week", MONTH: "month" },
    also_lines: "Left out: same row as line {line}",
    problems: {
      PRICE: "No readable price",
      CURRENCY: "Unknown currency",
      EMPTY: "No name and no article number",
      OTHER: "Not readable",
    },
    more: "1 more line – reachable through the filter | {n} more lines – reachable through the filter",
    empty: "No lines.",
    planned: "No line taken over | 1 line taken over | {n} lines taken over",
    from: "valid from",
  },
  refused_line: "Line {line} was not accepted.",
  actions: {
    back: "Back",
    next: "Next",
    apply: "Take over",
  },
  result: {
    title: "Price list taken over",
    updated: "1 price updated | {n} prices updated",
    rows_added: "1 new in the assortment | {n} new in the assortment",
    created: {
      MATERIAL: "1 material created | {n} materials created",
      MACHINE: "1 machine created | {n} machines created",
    },
    unchanged: "1 unchanged | {n} unchanged",
    skipped: "1 left out | {n} left out",
    nothing: "Nothing changed.",
  },
}
